export const isPractitioner = (
  value: fhir4.Practitioner | fhir4.Organization | fhir4.PractitionerRole | fhir4.Location
): value is fhir4.PractitionerRole => (value as fhir4.Practitioner)?.resourceType === 'Practitioner';

export const isOrganization = (
  value: fhir4.Practitioner | fhir4.Organization | fhir4.PractitionerRole | fhir4.Location
): value is fhir4.PractitionerRole => (value as fhir4.Organization)?.resourceType === 'Organization';

export const isRole = (value: fhir4.Practitioner | fhir4.Organization | fhir4.PractitionerRole | fhir4.Location): value is fhir4.PractitionerRole =>
  (value as fhir4.PractitionerRole)?.resourceType === 'PractitionerRole';

export const isLocation = (value: fhir4.Practitioner | fhir4.Organization | fhir4.PractitionerRole | fhir4.Location): value is fhir4.Location =>
  (value as fhir4.Location)?.resourceType === 'Location';
